import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "@/styles/globals.css";
import { Toast } from "@heroui/react";
import { CustomToast } from "@/components/custom-toast.jsx";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

const APP_VERSION = "0.0.1";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}

(async () => {
  const prev = localStorage.getItem("app_version");
  if (prev && prev !== APP_VERSION) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    } catch {}
  }
  localStorage.setItem("app_version", APP_VERSION);
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Toast.Provider placement="top end">
        {({ toast }) => <CustomToast toast={toast} />}
      </Toast.Provider>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);